module.exports = __webpack_public_path__ + "fonts/quasimoda-light.4cc86eff.otf";